module.exports = __webpack_public_path__ + "img/logo-mark.f585a9c3.svg";